module.exports = __webpack_public_path__ + "img/cms.5ed7d211.svg";